import React, { useState } from 'react';
import Company from './Company';
import CompanyHistory from './CompanyHistory';
import Popup from 'reactjs-popup';

import '../../../node_modules/reactjs-popup/dist/index.css';
import NewCompany from './NewCompany';

const UmCompany = () => {
    const [historyLoading, setHistoryLoading] = useState(false);
    const [companyLoading, setCompanyLoading] = useState(false);

    const reloadingCompany = () => {
        setTimeout(function () {
            setCompanyLoading(true);
        }, 1500);
    };

    return (
        <>
            <div className="companycontainer alert alert-white">
                <div className="divtable" style={{ height: "75vh" }}>
                    <div className="row ml-0 mr-0">
                        <div className="col-md-8 col-sm-8 pl-0">
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item">
                                    <a className="nav-link active nav-link-company" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" >Company List</a>
                                </li>
                                <li className="nav-item">
                                    <a className="nav-link nav-link-company" id="history-tab" data-toggle="tab" href="#history" role="tab" aria-controls="history" aria-selected="false" onClick={() => setHistoryLoading(true)} >History</a>
                                </li>

                            </ul>
                        </div>
                        <div className="col-md-4 col-sm-4 text-right pr-0">
                            <Popup trigger={<button type="button" className="btn btn-outline-primary btn-sm"><span><i className="fa fa-plus mr-1"></i></span>Add Company</button>} nested modal>{close => (<NewCompany id={0} callBack={reloadingCompany} onClose={() => { close(); }}></NewCompany>)}</Popup>
                        </div>
                    </div>
                    <div className="tab-content" id="myTabContent" style={{ height: "100%" }} >
                        <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab" style={{ height: "100%" }}>
                            <Company loading={companyLoading} />
                        </div>
                        <div className="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab" style={{ height: "100%" }}>
                            <CompanyHistory loading={historyLoading} />
                        </div>
                    </div >
                </div >
            </div >
        </>
    );
}

export default UmCompany;
